<template>
  <IndexPageSection
    :need-link="false"
    :section-name="'categories'"
    :title="'カテゴリから探す'"
  >
    <div class="categories__items">
      <a class="tl-list tl-list__text chevron--forward--black" :href="`/items`">
        すべて
      </a>
      <a
        v-for="category in categories"
        :key="category.id"
        class="tl-list tl-list__text chevron--forward--black"
        :href="`/items?category_id=${category.id}`"
      >
        {{ category.name }}
      </a>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection'
import axios from 'axios'
export default {
  components: { IndexPageSection },
  data() {
    return {
      categories: [],
      isCategoriesLoading: false
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    async getCategories() {
      this.isCategoriesLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/item_categories')
        this.categories = res.data.data
          .map(category => category.attributes)
          .map(({ id, name }) => ({ id, name }))
        this.isCategoriesLoading = false
      } catch (error) {
        this.isCategoriesLoading = false
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
    }
  }
}
</script>
